











import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class Checkbox extends Vue {
  @Prop({ default: false, required: false })
  public hasError!: boolean;

  @Prop()
  public value!: boolean;

  @Prop()
  public label!: string;

  public checked = false;

  @Watch('value', { immediate: true })
  public onValueChanged() {
    this.checked = this.value;
  }
}
